class AxiosIndicator {
    static register = {
        PRODUCT_LISTING_API_CALL: { slug: 'PRODUCT_LISTING_API_CALL' },
        UNIVERSAL_SEARCH_DEDICATED_API_BULK_CALL: { slug: 'UNIVERSAL_SEARCH_DEDICATED_API_BULK_CALL' },
        PRODUCT_MANUAL_SEARCH_LISTING_API_CALL: { slug: 'PRODUCT_MANUAL_SEARCH_LISTING_API_CALL' },
        SEND_CONTACT_US_EMAIL_API_CALL: { slug: 'SEND_CONTACT_US_EMAIL_API_CALL' },
        SEND_REPORT_ERROR_EMAIL_API_CALL: { slug: 'SEND_REPORT_ERROR_EMAIL_API_CALL' },
        PRODUCT_COMPARE_API_CALL: { slug: 'PRODUCT_COMPARE_API_CALL' },
        PRODUCT_INVENTORY_API_CALL: { slug: 'PRODUCT_INVENTORY_API_CALL' },
        CART_API_CALL: { slug: 'CART_API_CALL' },
        CART_OPERATION_API_CALL: { slug: 'CART_OPERATION_API_CALL' },
        VIEW_CART_API_CALL: { slug: 'VIEW_CART_API_CALL' },
        SET_DEFAULT_SHIPPING_ADDRESS_API_CALL: { slug: 'SET_DEFAULT_SHIPPING_ADDRESS_API_CALL' },
        BOM_API_CALL: { slug: 'BOM_API_CALL' },
        BOM_TAB_API_CALL: { slug: 'BOM_TAB_API_CALL' },
        BOM_PROJECT_API_CALL: { slug: 'BOM_PROJECT_API_CALL' },
        BOM_PROJECT_OPERATION_API_CALL: { slug: 'BOM_PROJECT_OPERATION_API_CALL' },
        BOM_PRODUCT_CATEGORY_API_CALL: { slug: 'BOM_PRODUCT_CATEGORY_API_CALL' },
        BOM_OPERATION_API_CALL: { slug: 'BOM_OPERATION_API_CALL' },
        BOM_REMATCH_FLAG_OPERATION_API_CALL: { slug: 'BOM_REMATCH_FLAG_OPERATION_API_CALL' },
        BOM_HEALTH_API_CALL: { slug: 'BOM_HEALTH_API_CALL' },
        BOM_DOWNLOAD_API_CALL: { slug: 'BOM_DOWNLOAD_API_CALL' },
        BOM_EMAIL_API_CALL: { slug: 'BOM_EMAIL_API_CALL' },
        BOM_SAVE_PREFERENCE_API_CALL: { slug: 'BOM_SAVE_PREFERENCE_API_CALL' },
        BOM_ASSIGN_TO_PROJECT_API_CALL: { slug: 'BOM_ASSIGN_TO_PROJECT_API_CALL' },
        BOM_SWAP_PART_NUMBER_API_CALL: { slug: 'BOM_SWAP_PART_NUMBER_API_CALL' },
        BOM_REMATCH_API_CALL: { SLUG: "BOM_REMATCH_API_CALL" },
        BOM_REMATCH_SAVED_API_CALL: { SLUG: "BOM_REMATCH_SAVED_API_CALL" },
        BOM_REMATCH_OPERATION_API_CALL: { SLUG: "BOM_REMATCH_OPERATION_API_CALL" },
        BOM_MULTIPLE_MATCH_PRODUCT_SEARCH: { SLUG: "BOM_MULTIPLE_MATCH_PRODUCT_SEARCH" },
        ORDER_API_CALL: { slug: 'ORDER_API_CALL' },
        QUOTE_API_CALL: { slug: 'QUOTE_API_CALL' },
        PLACE_ORDER_API_CALL: { slug: 'PLACE_ORDER_API_CALL' },
        ORDER_HEADER_DETAIL_API_CALL: { slug: 'ORDER_HEADER_DETAIL_API_CALL' },
        LINE_ITEM_API_CALL: { slug: 'LINE_ITEM_API_CALL' },
        COMMON_API_CALL: { slug: 'COMMON_API_CALL' },
        EXPORT_URL: { slug: 'EXPORT_URL' },
        MINI_CART_API_CALL: { slug: 'MINI_CART_API_CALL' },
        ADD_TO_CART_API_CALL: { slug: 'ADD_TO_CART_API_CALL' },
        DOCUMENT_API_CALL: { slug: 'DOCUMENT_API_CALL' },
        CONTENT_API_CALL: { slug: 'CONTENT_API_CALL' },
        NEW_PRODUCT_INFORMATION_API_CALL: { slug: 'NEW_PRODUCT_INFORMATION_API_CALL' },
        MANUAL_SEARCH_API_CALL: { slug: 'MANUAL_SEARCH_API_CALL' },
        PRODUCT_DETAIL_API_CALL_ON_PAGE_LOADING: { slug: 'PRODUCT_DETAIL_API_CALL_ON_PAGE_LOADING' },
        ADD_USER_API_CALL: { slug: 'ADD_USER_API_CALL' },
        USER_API_CALL: { slug: 'USER_API_CALL' },
        USER_DETAIL_API_CALL: { slug: 'USER_DETAIL_API_CALL' },
        USER_ACCOUNT_API_CALL: { slug: 'USER_ACCOUNT_API_CALL' },
        REGISTRATION_API_CALL: { slug: 'REGISTRATION_API_CALL' },
        CHECK_USER_EMAIL: { slug: 'CHECK_USER_EMAIL' },
        ACCOUNT_DETAIL_API_CALL: { slug: 'ACCOUNT_DETAIL_API_CALL' },
        ACCOUNT_USER_API_CALL: { slug: 'ACCOUNT_USER_API_CALL' },
        REMOVE_USER_API_CALL: { slug: 'REMOVE_USER_API_CALL' },
        ORDER_LINE_ITEM_EMAIL_API_CALL: { slug: 'ORDER_LINE_ITEM_EMAIL_API_CALL' },
        UN_SPONSOR_API_CALL: { slug: 'UN_SPONSOR_API_CALL' },
        VALIDATE_ORDER_API_CALL: { slug: 'VALIDATE_ORDER_API_CALL' },
        CART_TAX_API_CALL: { slug: 'CART_TAX_API_CALL' },
        TAX_EXEMPT_FILE_UPLOAD: { slug: 'TAX_EXEMPT_FILE_UPLOAD' },
        CARRIER_OPTION_UPDATE: { slug: 'CARRIER_OPTION_UPDATE' },
        PROFILE_ACCOUNT_INFORMATION: { slug: 'PROFILE_ACCOUNT_INFORMATION' },
        REQUEST_NEW_QUOTE: { slug: 'REQUEST_NEW_QUOTE' },
        CART_TOTAL_SUMMARY_CALCULATION: { slug: 'CART_TOTAL_SUMMARY_CALCULATION' },
        EXCHANGE_RATE_API_CALL: { slug: 'EXCHANGE_RATE_API_CALL' },
        BOM_MANAGEMENT_API_CALL: { slug: 'BOM_MANAGEMENT_API_CALL' },
        PRODUCT_ASSET_API_CALL: { slug: 'PRODUCT_ASSET_API_CALL' },
        UPDATE_CART_QTY_API_CALL: { slug: 'UPDATE_CART_QTY_API_CALL' },
        ADMIN_COMPLIANCE_MANAGEMENT_API_CALL: { slug: 'ADMIN_COMPLIANCE_MANAGEMENT_API_CALL' },
        GET_COMPLIANCE_DATA: { slug: 'GET_COMPLIANCE_DATA' },
        ADMIN_ORDER_LIST: { slug: 'ADMIN_ORDER_LIST' },
        GET_ORDER_DETAIL: { slug: 'GET_ORDER_DETAIL' },
        ORDER_REPROCESS: { slug: 'ORDER_REPROCESS' },
        CHECKOUT_CALL: { slug: 'CHECKOUT_CALL' },
        ALL_CONTENT_COUNT_API_CALL: { slug: 'ALL_CONTENT_COUNT_API_CALL' },
        BOM_PROJECT_API_CALL_GUEST: { slug: 'BOM_PROJECT_API_CALL_GUEST' },
        VALIDATE_CART_API_CALL: { slug: 'VALIDATE_CART_API_CALL' },
        ADD_PROFILE_ADDRESS_API_CALL: { slug: 'ADD_PROFILE_ADDRESS_API_CALL' },
        BOM_CREATE_API_CALL: { slug: 'BOM_CREATE_API_CALL' },
        BOM_ADD_TO_BOM_API_CALL: { slug: 'BOM_ADD_TO_BOM_API_CALL' },
        ADD_TO_QUOTE_API_CALL: { slug: 'ADD_TO_QUOTE_API_CALL' },
        EDIT_QUOTE_API_CALL: { slug: 'EDIT_QUOTE_API_CALL' },
        DELETE_QUOTE_API_CALL: { slug: 'DELETE_QUOTE_API_CALL' },
        CLEAR_CART_API_CALL: { slug: 'CLEAR_CART_API_CALL' },
        GET_CART_API_CALL: { slug: 'GET_CART_API_CALL' },
        ADD_COMPLIANCE_DATA: { slug: 'ADD_COMPLIANCE_DATA' },
        VALIDATE_ADDRESS_API_CALL: { slug: 'VALIDATE_ADDRESS_API_CALL' },
        Bom_Alternative_API_CALL: { slug: 'Bom_Alternative_API_CALL'},
        CLEAR_QUOTE_API_CALL: { slug: 'CLEAR_QUOTE_API_CALL' },
        BOM_NEWARK_LIST_API_CALL: {slug: 'BOM_NEWARK_LIST_API_CALL'},
        PRODUCT_FACETS_API_CALL: { slug: 'PRODUCT_FACETS_API_CALL' },
        ADMIN_AUDIT_LOG_LIST: { slug: 'ADMIN_AUDIT_LOG_LIST' },
        CLEAR_QUOTE_CART_ITEM: { slug: 'CLEAR_QUOTE_CART_ITEM' },
    };
}

export default AxiosIndicator;